"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UWSAdapter = void 0;
const lodash_1 = require("lodash");
const Adapter_1 = require("./Adapter");
const ParserService_1 = require("./ParserService");
const Types_1 = require("./Types");
class UWSAdapter extends Adapter_1.Adapter {
    constructor(options, uwsOptions) {
        super(options);
        this.uwsOptions = {
            retryInterval: 1000,
            maxRetryInterval: 10000,
            maxRetryAttempts: null,
            timeoutInterval: 2000,
            retryExponent: 2,
        };
        this.retryAttempts = 0;
        if (lodash_1.isNil(options.productId)) {
            throw new Error(Types_1.BusErrors.MissingProductIdError);
        }
        this.setName();
        this.uwsOptions = { ...this.uwsOptions, ...uwsOptions };
    }
    addInitialSubscription() {
        const initialSubscription = {
            type: Types_1.ChannelType.Product,
            action: 'subscribe',
            data: {
                productId: this.options.productId,
            }
        };
        this.sendMessage(initialSubscription);
    }
    onOpenCallback() {
        clearInterval(this.timeoutId);
        clearInterval(this.retryId);
        this.addInitialSubscription();
    }
    onMessageCallback(event) {
        const data = JSON.parse(event.data);
        ParserService_1.parseAndDispatchEvent(data.event, data, this.useCommonEventName, this.name, this.options.proxyEvents, this.options.bounceToFrames);
    }
    onCloseCallback() {
        const { retryInterval, maxRetryInterval, retryExponent } = this.uwsOptions;
        const exponentialTimeout = retryInterval * Math.pow(this.retryAttempts, retryExponent);
        // It will try to reconnect every time it fails
        // and timeout will increase exponentially
        this.retryId = setTimeout(() => {
            this.retryAttempts++;
            this.createWS(true);
        }, exponentialTimeout > maxRetryInterval ? maxRetryInterval : exponentialTimeout);
    }
    setListeners() {
        var _a, _b, _c;
        (_a = this.instance) === null || _a === void 0 ? void 0 : _a.addEventListener('open', this.onOpenCallback.bind(this));
        (_b = this.instance) === null || _b === void 0 ? void 0 : _b.addEventListener('message', this.onMessageCallback.bind(this));
        (_c = this.instance) === null || _c === void 0 ? void 0 : _c.addEventListener('close', this.onCloseCallback.bind(this));
    }
    removeListeners() {
        var _a, _b, _c;
        (_a = this.instance) === null || _a === void 0 ? void 0 : _a.removeEventListener('open', this.onOpenCallback.bind(this));
        (_b = this.instance) === null || _b === void 0 ? void 0 : _b.removeEventListener('message', this.onMessageCallback.bind(this));
        (_c = this.instance) === null || _c === void 0 ? void 0 : _c.removeEventListener('close', this.onCloseCallback.bind(this));
    }
    subscribe() {
        this.setListeners();
    }
    unsubscribe() {
        this.removeListeners();
    }
    createWS(retryAttempt) {
        clearTimeout(this.retryId);
        const { maxRetryAttempts, timeoutInterval } = this.uwsOptions;
        // If it is retry attempt and it is bigger than max retry attempts
        // stop trying to reconnect
        if (retryAttempt) {
            if (!lodash_1.isNil(maxRetryAttempts)
                && this.retryAttempts > maxRetryAttempts)
                return;
        }
        else {
            this.retryAttempts = 0;
        }
        if (!lodash_1.isNil(this.instance)) {
            this.unsubscribe();
            this.instance = undefined;
        }
        this.instance = new WebSocket(this.getEndpoint());
        this.subscribe();
        // If defined timeout is passed and socket is not connected
        // try to reconnect after timeout
        this.timeoutId = setTimeout(() => {
            var _a;
            if (Types_1.WSStates.CONNECTING) {
                (_a = this.instance) === null || _a === void 0 ? void 0 : _a.close();
            }
        }, timeoutInterval);
    }
    getEndpoint() {
        switch (this.options.environment) {
            case 'production':
                console.warn(`[Bus Service - ${this.name}] Production environment is not supported yet.`);
                return '';
            default:
                return 'wss://crash-socket-mock.herokuapp.com/';
        }
    }
    addChannel(channelType, channelName) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, channelName);
    }
    removeChannel(channelType, channelName) {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`, channelName);
    }
    setName() {
        this.name = Types_1.Adapters.UWSAdapter;
    }
    sendMessage(message) {
        var _a;
        (_a = this.instance) === null || _a === void 0 ? void 0 : _a.send(JSON.stringify(message));
    }
    connect() {
        this.createWS();
    }
    reconnect() {
        var _a;
        if (((_a = this.instance) === null || _a === void 0 ? void 0 : _a.readyState) === Types_1.WSStates.CLOSED) {
            this.connect();
        }
    }
    disconnect() {
        var _a;
        this.unsubscribe();
        (_a = this.instance) === null || _a === void 0 ? void 0 : _a.close();
        this.instance = undefined;
    }
    async getState() {
        console.warn(`${this.name}: ${Types_1.BusErrors.MethodNotImplementedError}`);
    }
}
exports.UWSAdapter = UWSAdapter;
//# sourceMappingURL=UWSAdapter.js.map